import { Box, Container, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import axios from 'axios';
import { API_URL, APP_URL } from '../../Config';

const Rankingdetails = () => {
    const [ranking, setranking] = useState([]);
    const [currency, setcurrency] = useState("BNB");
    const fetchranking = async () => {

        return await axios.get(`${API_URL}/indexData.php?type=tranding&currency=${currency && currency}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then(res => {
           setranking(res.data);
        })
    }

    useEffect(() => {
        fetchranking();
    }, [currency])
    return (
        <>
            <Box className='createcollection_bg'>
                <Typography variant='h2' fontWeight='600' fontSize='45px'>
                    Ranking Details
                </Typography>
            </Box>

            <Box className='ranking_selector'>
                <Container maxWidth='xl'>
                    <Grid container spacing={2}>
                        <Grid item lg={4} sm={12} md={12} xs={12}>
                            <FormControl fullWidth>
                                <NativeSelect defaultValue="BNB" onChange={(e) => setcurrency(e.target.value)} >
                                    <option value='BNB'>BNB</option>
                                    <option value='MATIC'>MATIC</option>
                                </NativeSelect>
                            </FormControl>
                        </Grid>

                        <Grid item lg={12} sm={12} md={12} xs={12}>
                            <Box className='' marginY={3}>
                                <TableContainer component={Paper} className='cadssd'>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>COLLECTION</TableCell>
                                                <TableCell align="center">FLOOR PRICE</TableCell>
                                                <TableCell align="center">VOLUME</TableCell>

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {ranking && ranking.map((data, idx) => (
                                                <TableRow key={idx} >
                                                    <TableCell component="th" scope="row">
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}>

                                                            <Box>
                                                                <img alt='' className='tab_pht' src={data.collection_logo && APP_URL + '/' + data.collection_logo} />
                                                            </Box>
                                                            <Box>
                                                                <Typography variant='h6'>
                                                                    {data.collection}
                                                                </Typography>
                                                            </Box>
                                                        </Box>

                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Box>
                                                            <Typography variant='h6'>
                                                                {Number(data.floorPrice).toFixed(4)} {currency}
                                                            </Typography>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Box>
                                                            <Typography variant='h6'>
                                                                {Number(data.amount).toFixed(4)} {currency}
                                                            </Typography>
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            ))}


                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            {/* <Rankingcopy /> */}

        </>
    )
}

export default Rankingdetails;